(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Common"] = factory();
	else
		root["Common"] = factory();
})(typeof window !== 'undefined' ? window : this, function() {
return 